export type USStateData = {
  name: string;
  iso2code: string;
};

export const washingtonDCUSStateData: USStateData = {
  name: "District of Columbia",
  iso2code: "DC",
};
export const usStateData = [
  { name: "Alabama", iso2code: "AL" },
  { name: "Alaska", iso2code: "AK" },
  { name: "Arizona", iso2code: "AZ" },
  { name: "Arkansas", iso2code: "AR" },
  { name: "California", iso2code: "CA" },
  { name: "Colorado", iso2code: "CO" },
  { name: "Connecticut", iso2code: "CT" },
  { name: "Delaware", iso2code: "DE" },
  washingtonDCUSStateData,
  { name: "Florida", iso2code: "FL" },
  { name: "Georgia", iso2code: "GA" },
  { name: "Hawaii", iso2code: "HI" },
  { name: "Idaho", iso2code: "ID" },
  { name: "Illinois", iso2code: "IL" },
  { name: "Indiana", iso2code: "IN" },
  { name: "Iowa", iso2code: "IA" },
  { name: "Kansas", iso2code: "KS" },
  { name: "Kentucky", iso2code: "KY" },
  { name: "Louisiana", iso2code: "LA" },
  { name: "Maine", iso2code: "ME" },
  { name: "Maryland", iso2code: "MD" },
  { name: "Massachusetts", iso2code: "MA" },
  { name: "Michigan", iso2code: "MI" },
  { name: "Minnesota", iso2code: "MN" },
  { name: "Mississippi", iso2code: "MS" },
  { name: "Missouri", iso2code: "MO" },
  { name: "Montana", iso2code: "MT" },
  { name: "Nebraska", iso2code: "NE" },
  { name: "Nevada", iso2code: "NV" },
  { name: "New Hampshire", iso2code: "NH" },
  { name: "New Jersey", iso2code: "NJ" },
  { name: "New Mexico", iso2code: "NM" },
  { name: "New York", iso2code: "NY" },
  { name: "North Carolina", iso2code: "NC" },
  { name: "North Dakota", iso2code: "ND" },
  { name: "Ohio", iso2code: "OH" },
  { name: "Oklahoma", iso2code: "OK" },
  { name: "Oregon", iso2code: "OR" },
  { name: "Pennsylvania", iso2code: "PA" },
  { name: "Rhode Island", iso2code: "RI" },
  { name: "South Carolina", iso2code: "SC" },
  { name: "South Dakota", iso2code: "SD" },
  { name: "Tennessee", iso2code: "TN" },
  { name: "Texas", iso2code: "TX" },
  { name: "Utah", iso2code: "UT" },
  { name: "Vermont", iso2code: "VT" },
  { name: "Virginia", iso2code: "VA" },
  { name: "Washington", iso2code: "WA" },
  { name: "West Virginia", iso2code: "WV" },
  { name: "Wisconsin", iso2code: "WI" },
  { name: "Wyoming", iso2code: "WY" },
  { name: "American Samoa", iso2code: "AS" },
  { name: "Guam", iso2code: "GU" },
  { name: "Northern Mariana Islands", iso2code: "MP" },
  { name: "Puerto Rico", iso2code: "PR" },
  { name: "U.S. Virgin Islands", iso2code: "VI" },
];
